// Libraries
import { TypeOf, ZodType, z } from 'zod';
// Constants
import { HttpStatusCodeEnum } from '@constants/index';

export const VesselSchema = z.object({
  imo: z.number().or(z.string()),
  vesselName: z.string(),
  vesselType: z.string(),
  vesselTypeId: z.number(),
  shipyard: z.string(),
  yearBuilt: z.number(),
  deadWeightTonnage: z.number(),
});

export const RatingsSchema = z.object({
  A: z.number(),
  B: z.number(),
  C: z.number(),
  D: z.number(),
  E: z.number(),
});

export const FactorSchema = z.object({
  factor: z.string(),
  value: z.number(),
  units: z.string().optional(),
});

export const ResistanceSchema = z.object({
  timestamp: z.string(),
  resistance: z.number(),
});

export type Ratings = TypeOf<typeof RatingsSchema>;

export const HttpStatusCodeSchema = z.nativeEnum(HttpStatusCodeEnum);

/**
 * BuildResponse function.
 * Constructs a response object with a specified data type.
 *
 * @template Data - The type of the data payload.
 * @param {ZodType<Data>} data - The Zod type for the data payload.
 * @returns {object} - The response object.
 */
export const buildResponse = <Data>(data: ZodType<Data>) =>
  z.object({
    status: HttpStatusCodeSchema,
    data,
  });

export const ServiceErrorSchema = z.object({
  error: z.object({
    message: z.string(),
    name: z.string(),
  }),
  status: HttpStatusCodeSchema,
});

export type ServiceError = TypeOf<typeof ServiceErrorSchema>;
